import { EmbedMessage } from '@/embed/EmbedMessage';
import type { EmbedWidgetProps } from '@/embed/types';

/**
 * The Contact widget — a ready-but-empty placeholder. The embed framework and
 * its registry entry exist so adding a real Contact action later is a one-file
 * change; there is nothing concrete to expose here yet.
 *
 * @returns The Contact actions placeholder.
 */
export function ContactActions(_props: EmbedWidgetProps): React.ReactElement {
  return <EmbedMessage text="bcecloud actions for a contact will appear here as they are built." />;
}
